import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center gap-4">
      {/* Custom Logo Image - Much Bigger Size */}
      <img 
        src="/logo.png" 
        alt="K&B Auto Services Logo" 
        className="h-20 w-20 object-contain"
        style={{ filter: 'drop-shadow(0 0 12px rgba(255, 100, 100, 0.5))' }}
      />
      
      {/* Brand Text with Aptos Bold Font */}
      <div className="flex flex-col leading-tight">
        <span className="text-red-600 text-2xl tracking-wider uppercase" style={{ fontFamily: "Aptos, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif", fontWeight: '700', letterSpacing: '0.1em', textShadow: '0 0 10px rgba(255, 0, 0, 0.5)' }}>
          K&B AUTO
        </span>
        <span className="text-white text-xs tracking-widest uppercase" style={{ fontFamily: "Aptos, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif", fontWeight: '700', letterSpacing: '0.15em' }}>SERVICES INC.</span>
      </div>

      <style jsx>{`
        .neon-stroke {
          filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 15px rgba(255, 255, 255, 0.5));
        }
        .neon-stroke-red {
          filter: drop-shadow(0 0 8px rgba(255, 0, 0, 0.8)) drop-shadow(0 0 15px rgba(255, 0, 0, 0.5));
        }
        .logo-glow {
          filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0.3));
        }
      `}</style>
    </div>
  );
};

export default Logo;